import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import Toggle from '../Toggle'
import TransomConfigurator from './../TransomConfigurator'
import { withTranslation, Trans } from 'react-i18next'
import { view01ImageOptions } from './views/view01'

class X46Deck extends Component {
  constructor (props) {
    super(props)
    this.handleDeckChange = this.handleDeckChange.bind(this)
    this.handleTeakOnSideDecksChange =
      this.handleTeakOnSideDecksChange.bind(this)
    this.handleTeakOnCoachroofChange =
      this.handleTeakOnCoachroofChange.bind(this)
  }

  handleDeckChange (newValue) {
    let configuration = this.props.configuration
    configuration.Deck = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleTeakOnSideDecksChange (event) {
    let configuration = this.props.configuration
    configuration.TeakOnSideDecks = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleTeakOnCoachroofChange (event) {
    let configuration = this.props.configuration
    configuration.TeakOnCoachroof = event.target.checked
      ? { value: 2, label: 'true' }
      : { value: 1, label: 'false' }

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    let imageOptions = view01ImageOptions

    let image = (
      <TransomConfigurator
        colorMultiplier={0.75}
        name={this.props.transom.Name}
        port={this.props.transom.Port}
        transomSize={{ width: 2895, height: 780 }}
        transform={[
          0.062357, -0.000963, 0, -2.3e-5, 0.003397, 0.097934, 0, 5.6e-6, 0, 0,
          1, 0, 220.028066, 404.093037, 0, 1
        ]}
      >
        <ConfiguratorImage
          boat='X4_6'
          configuration={this.props.configuration}
          options={imageOptions}
        />
      </TransomConfigurator>
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Deck & cockpit' />
          </h1>
          <p>
            <Trans defaults='Standard on the X4<sup>6</sup> is genuine teak on cockpit floor and seats. Genuine teak is with black caulkings and optional is Flexiteek finish with grey stripes.' />
          </p>

          <RadioGroup
            label={this.props.t('Deck material:')}
            options={this.props.deckOptions}
            value={this.props.configuration.Deck}
            onChange={this.handleDeckChange}
          />

          <h3>
            <Trans defaults='Deck options:' />
          </h3>

          <Toggle
            checked={this.props.configuration.TeakOnSideDecks.value === 2}
            onChange={this.handleTeakOnSideDecksChange}
          >
            <Trans
              defaults='{{wood}} on side decks'
              values={{
                wood:
                  this.props.configuration.Deck.value === 1
                    ? 'Teak'
                    : 'Flexiteek'
              }}
            />
          </Toggle>
          <Toggle
            checked={this.props.configuration.TeakOnCoachroof.value === 2}
            onChange={this.handleTeakOnCoachroofChange}
          >
            <Trans
              defaults='{{wood}} on coachroof'
              values={{
                wood:
                  this.props.configuration.Deck.value === 1
                    ? 'Teak'
                    : 'Flexiteek'
              }}
            />
          </Toggle>
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46Deck)



// WEBPACK FOOTER //
// ./src/X46/X46Deck.js